import React from 'react';
import { FormattedMessage } from 'react-intl';
import HoverActionButtons from '@/components/buttons/HoverActionButtons';
import MessageRow from '@/components/table/MessageRow';

const DatasetCohortMinValueSettingRow = ({
  canEdit,
  labelWidth,
  showEdit,
  value,
}) => (
  <MessageRow
    message="dataset.settings.cohort.minimum.size"
    context="dataset.setting"
    icons={['stop circle']}
    entity="cohort"
    labelWidth={labelWidth}
  >
    <HoverActionButtons
      canEdit={canEdit}
      showEdit={showEdit}
      value={value}
      copyToClipboard={false}
    >
      <span>
        {value || (<FormattedMessage id="dataset.settings.cohort.minimum.size.not.set" />)}
      </span>
    </HoverActionButtons>
  </MessageRow>
);

export default DatasetCohortMinValueSettingRow;
